import { useSearchParams } from "react-router-dom";
import Index from "./Index";
import Landing from "./Landing";
import { useLandingSettings } from "@/hooks/useLandingPage";

/**
 * Decides what visitors see at "/".
 * When the landing page is switched on in the admin portal it takes over the
 * homepage. Adding ?site=1 always shows the normal homepage, so the main site
 * can still be worked on while the landing page is live.
 */
const RootPage = () => {
  const [searchParams] = useSearchParams();
  const forceSite = searchParams.get("site") === "1";
  const { data: settings, isLoading } = useLandingSettings();

  if (forceSite) return <Index />;

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return settings?.is_enabled ? <Landing /> : <Index />;
};

export default RootPage;
